import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';


/*

Props:


*/

const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-color: none;
  border: none;
  border-width: 0px;
  background: none;
  color: ${props => props.textColor};
  font-size: ${props => (props.fontSize) ? props.fontSize+'px' : '16px'};
  letter-spacing: ${props => (props.light) ? '0.04em' : '0em'};
  font-weight: ${props => (props.strong) ? 500 : 100};
  font-family: ${constants.text.displayFont.fontFamily};
  ${props => (props.hoverEffect) ? 
  `:hover { 
    text-decoration: underline;
  }` : ''
  }
`;

const TextButton = ({color, dark=false, light=false, altColor=false, altDark=false, style, onClick, children, ...rest }) => {
  let textColor = '';
  
  if (color) {
      textColor = color;
  }
  else if (altColor) {
      textColor = constants.color.grey34;
  }
  else if (altDark) {
      textColor = constants.color.grey75;
  }
  else if (dark) {
      textColor = constants.color.dark;
  }
  else if (light) {
      textColor = constants.color.light;
  } else {
      textColor = constants.color.primaryDark;
  }
  
  return (
    <StyledButton style = {style} textColor={textColor} light={light}  onClick = {onClick} {...rest} >
        { children }
    </StyledButton>
  )
}
export default TextButton


// WEBPACK FOOTER //
// ./src/js/components/Button/TextButton.jsx